import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CapacityPricingWarningsDto } from "../../../models/court/dto/capacity-pricing-warning.dto";
import { CourtDto } from "../../../models/court/dto/court.dto";
import { GET_LOCATION_COURTS_QUERY_KEY } from "./useGetCourts";

export const useDeleteCourt = (courtId: number, locationId: string) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['delete', courtId],
        // The body was `{}` and now additively carries what archiving this
        // court took away (D136) — every size it was the last to price leaves
        // the sellable set with it, silently, on every surface.
        mutationFn: () => apiClient.fetchApi<CapacityPricingWarningsDto, {}>({ method: 'POST', endpoint: `courts/${courtId}/delete` }),
        onSuccess: () => {
            queryClient.setQueryData(GET_LOCATION_COURTS_QUERY_KEY(locationId), (oldData: CourtDto[]) => {
                return oldData.filter((court) => court.id !== courtId);
            });
        }
    });
};